import { AnalyticsBrowser } from '@segment/analytics-next';
import { projectID } from '../../database/firebaseConfig/helpers.js';
import { isEmulatedFunctions } from '../../database/firebaseConfig/init.js';

const analytics = new AnalyticsBrowser();
const getSegmentAPIHost = () => {
    const baseURL = isEmulatedFunctions
        ? 'localhost:5001/caresend-dev/us-central1'
        : `us-central1-${projectID}.cloudfunctions.net`;
    const endpoint = '/webApi/api/v0/segment';
    return `${baseURL}${endpoint}`;
};
const initSegment = (writeKey) => {
    analytics.load({ writeKey }, {
        integrations: {
            'Segment.io': {
                apiHost: getSegmentAPIHost(),
                protocol: isEmulatedFunctions ? 'http' : 'https',
            },
        },
    });
};

export { analytics, initSegment };
